import { render, staticRenderFns } from "./DomainStatusChanges.vue?vue&type=template&id=195d76ca&"
import script from "./DomainStatusChanges.vue?vue&type=script&lang=js&"
export * from "./DomainStatusChanges.vue?vue&type=script&lang=js&"
import style0 from "./DomainStatusChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports